module.exports = __webpack_public_path__ + "static/media/ic_close.771609a3.svg";